<template>
  <div class="page home">
    <home-skeleton v-if="loading" style="margin-top: 30px"></home-skeleton>

    <div v-else>
      <div class="home-wapper-bg-1"></div>
      <div class="home-wapper-bg-2"></div>
      <div class="home-wapper-bg-3"></div>
      <div class="home-wapper-bg-4"></div>
      <div class="home-container">
        <!-- 搜索区域 -->
        <div class="home-container-header">
          <van-search
            shape="round"
            class="header-search"
            @click="goSearch()"
            v-model="value"
            placeholder="搜一搜"
            background="#30D6BEFF"
          />
        </div>

        <div class="home-container-main-box">
          <van-grid column-num="3" active-color="#404040" v-model="active" :fixed="false" :border="false">
            <van-grid-item @click="goList('anticancer', '抗癌百科', 1)" class="home-main-nav">
              <van-image src="/static/bytx/new-home/home_head_icon_1@3x.png" />
              <div class="title">抗癌百科</div>
              <div>权威科普 尽在掌握</div>
            </van-grid-item>
            <van-grid-item @click="goList('medical-services', '医疗服务', 1)" class="home-main-nav">
              <van-image src="/static/bytx/new-home/home_head_icon_2@3x.png" />
              <div class="title">医疗服务</div>
              <div>在线咨询 送药到家</div>
            </van-grid-item>
            <van-grid-item @click="goList('welfare-zone', '公益救助', 1)" class="home-main-nav">
              <van-image src="/static/bytx/new-home/home_head_icon_3@3x.png" />
              <div class="title">公益救助</div>
              <div>携手公益 为爱同行</div>
            </van-grid-item>
          </van-grid>
        </div>

        <div class="home-container-nav-box">
          <van-grid column-num="5" active-color="#404040" v-model="active" :fixed="false" :border="false">
            <van-grid-item
              class="home-container-nav-box-item"
              v-for="(item, index) in navList"
              :key="index"
              v-show="index <= 9"
            >
              <div
                @click="onClickNavItem(item, index)"
                v-if="(navList.length <= 10 && index <= 9) || (navList.length > 10 && index <= 8)"
              >
                <van-image :src="item.logo" />
                <div class="title">{{ item.title }}</div>
              </div>
              <div @click="showMore()" v-else-if="navList.length > 10 && index === 9">
                <van-image class="new-more" src="/static/bytx/home_head_more_icon.svg" />
                <div class="title">更多</div>
              </div>
            </van-grid-item>
          </van-grid>

          <!-- 通告滚动文字 -->
          <div class="home-container-nav-box-announcement" @click="goLink">
            <van-notice-bar :scrollable="false" background="#E6F9F4">
              <template slot="left-icon">
                <van-image src="/static/bytx/new-home/home_new_icon@3x.png" />
              </template>
              <template slot="right-icon">
                <van-image class="notice-bar-right" src="/static/bytx/new-home/home_more_icon@3x.png" />
              </template>
              <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="3000"
                :show-indicators="false"
                @change="onSwipeChange"
              >
                <van-swipe-item v-for="item in message_notice" :key="item.id">
                  <div class="message_notice-text">{{ item.title }}</div>
                </van-swipe-item>
              </van-swipe>
            </van-notice-bar>
          </div>
        </div>

        <div class="swipe home-swiper">
          <van-swipe :autoplay="3000" indicator-color="#fff">
            <van-swipe-item v-for="(item, i) in banners" :key="i" @click="goBanner(item)">
              <!-- <a :href="item.target_url.replace('https://bytx.care-gobroad.com', '')"> -->
              <a @click.prevent="toLink(item.target_url)">
                <img :src="item.img" alt="" />
              </a>
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- 预约直播 看直播 -->
        <div class="live-broadcast-container">
          <div class="live-broadcast-container-wapper">
            <div class="live-broadcast-container-wapper-title">
              <span>预约直播 看直播</span>
              <span @click="goMore()">查看更多<van-icon name="arrow" /> </span>
            </div>
            <div class="live-broadcast-container-wapper-content">
              <div
                class="live-broadcast-container-wapper-content-card"
                @click="go_live_detail(item)"
                v-for="item in lives"
                :key="item.id"
              >
                <div class="banner" v-if="item.live_status == 0">
                  <van-image :src="item.cover_img" />
                  <div class="type-tips">
                    <span style="margin-left: 3px">预告</span>
                    <span
                    >距直播 <van-count-down :time="item.timeLimit" :format="item.timeFormat"
                    /></span>
                  </div>
                </div>
                <div class="banner" v-else-if="item.live_status == 1">
                  <van-image :src="item.cover_img" />
                  <!-- 图标 -->
                  <van-image class="tips" src="/static/bytx/new-home/tag_live_icon@3x.png" />
                </div>
                <div class="banner" v-else>
                  <van-image :src="item.cover_img" />
                  <!-- 图标 -->
                  <van-image
                    class="tips_back"
                    src="/static/bytx/new-home/tag_live_icon_back@3x.svg"
                  />
                </div>
                <div class="describe">
                  <span class="title">{{ item.title }}</span>
                  <div class="operation">
                    <span class="operation-date">{{ item.start_at }}</span>
                    <van-button type="primary" v-if="item.live_status == 1" color="#1FCFC1FF" round size="small">进入直播间</van-button>
                    <van-button type="primary" v-if="item.live_status == 0" color="#1FCFC1FF" round size="small">{{item.isAppointment ? '已预约' : '一键预约'}}</van-button>
                    <van-button type="info" v-if="item.live_status > 1" color="#1FCFC1FF" round size="small">看回放</van-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>

        <div class="home-section">
          <div class="home-title">内容精选</div>
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="onLoad">
              <ContentSelection :dataItem="recommend" :contentType="1"/>
            </van-list>
          </van-pull-refresh>
        </div>
        <div class="clear"></div>
      </div>
      <van-tabbar
        class="home-footer"
        :fixed="true"
        :safe-area-inset-bottom="true"
        v-model="active"
        active-color="#0FB7AD"
      >
        <van-tabbar-item icon="/static/bytx/tab_1_selected_icon.svg">首页</van-tabbar-item>
        <van-tabbar-item icon="/static/bytx/home/tab_2_icon.svg" :to="'live-list'">看直播</van-tabbar-item>
        <van-tabbar-item icon="/static/bytx/home/tab_3_icon.svg" :to="'comrade-list'">交流社区</van-tabbar-item>
        <van-tabbar-item icon="/static/bytx/home/tab_4_icon.svg" :to="'my'">我的</van-tabbar-item>
      </van-tabbar>

      <van-overlay class-name="home-overlay-wapper" :show="overlayShow" @click="overlayShow = false">
        <div class="home-overlay" @click.stop>
          <div class="home-overlay-header">
            <span>更多分类</span>
            <van-icon name="close" @click="overlayShow = false" />
          </div>
          <van-grid column-num="5" active-color="#404040" v-model="active" :fixed="false" :border="false">
            <van-grid-item
              class="home-container-nav-box-item"
              v-for="(item, index) in navList"
              :key="index"
              @click="goNavItem(item, index)"
            >
              <van-image :src="item.logo" />
              <div class="title">{{ item.title }}</div>
            </van-grid-item>
          </van-grid>
        </div>
      </van-overlay>
      <van-overlay :show="adShow" class-name="ad-overlay">
        <div class="ad-overlay-wrapper">
          <div class="ad-overlay-wrapper-image" @click="adJump()">
            <img
              v-if="screen_advert && screen_advert.length"
              :src="screen_advert && screen_advert.length ? screen_advert[0].cover_img : ''"
              alt=""
            />
          </div>
          <div class="ad-overlay-wrapper-close">
            <img src="/static/bytx/detail_share_close_icon.svg" @click="adShow = false" />
          </div>
        </div>
      </van-overlay>
    </div>
    <!-- 在线咨询  || 咨询医生 -->
    <Consult ref="Refconsult" :pageType=1></Consult>
    <!-- 开药 -->
    <Prescribe ref="RefPrescribe" :pageType=1></Prescribe>

    <!-- 专家推荐 -->
    <!-- <Recommend ref="RefRecommend"></Recommend> -->
  </div>
</template>

<script>
import Interface from '@/util/interface'
import homeSkeleton from '@/skeleton/homeSkeleton'
import { Consult, Prescribe } from '@/components/overlay'
import ContentSelection from '@/components/contentSelection/index.vue'
import {LocationHref} from '@/util/common'

export default {
  name: 'home',
  components: {
    'home-skeleton': homeSkeleton,
    Consult,
    Prescribe,
    ContentSelection
  },
  data() {
    return {
      overlayShow: false,
      navList: [],
      appid: 'gh_2af07dce0869',
      doctor_path: 'pages/doctorModule/doctorList/index.html?routerName=expertList',
      value: '',
      banners: [],
      recommend: [],
      articles: [],
      active: 0,
      loading: true,
      page: 1,
      pageSize: 10,
      total_page: 1,
      message_notice: [],
      swiperOption: {
        width: 192,
        height: 249,
        spaceBetween: 15
      },
      adShow: false,
      screen_advert: [],
      listLoading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      activeSwiper: 0,
      record_id: 0
    }
  },
  methods: {
    onClickNavItem(row, scene) {
      Interface.mFootPrint(row.id,63,0,1,0,0,0,row.title)
      if (row.title === '在线咨询') {
        this.$refs.Refconsult.overlayShow = true
        return
      }
      if (row.title === '线上开药') {
        this.$refs.RefPrescribe.overlayShow = true
        return
      }

      row.link = row.link.replace('https://bytx.care-gobroad.com', '')
      LocationHref(row.link)
    },
    toLink(url){
      const links = url.replace('https://bytx.care-gobroad.com', '')
      LocationHref(links)
    },
    showMore() {
      this.overlayShow = true
    },
    go(item){
      Interface.footPrint1('62', item.id)
    },
    goNavItem(row, scene) {
      Interface.mFootPrint(row.id,63,0,1,0,0,0,row.title)
      if (row.title === '在线咨询') {
        this.$refs.Refconsult.overlayShow = true
        return
      }
      if (row.title === '线上开药') {
        this.$refs.RefPrescribe.overlayShow = true
        return
      }
      row.link = row.link.replace('https://bytx.care-gobroad.com', '')
      LocationHref(row.link)
    },
    handleNavigation() {
      this.$router.push({
        name: row
      })
    },
    fetch(scene) {
      if (scene === 'homepage') {
        Interface.getData('get', Interface.home).then(res => {
          this.navList = res.data.positions
          this.message_notice = res.data.message_notice

          res.data.lives.forEach((item, i) => {
            if (item.live_status == 0) {
              let timeLimit = item.limit_time
              let timeFormat = ''
              if (timeLimit > 86400000) {
                timeFormat = 'DD天HH时mm分'
              } else if (timeLimit > 3600000) {
                timeFormat = 'HH时mm分'
              } else if (timeLimit > 60000) {
                timeFormat = 'mm分'
              } else {
                timeFormat = 'ss秒'
              }
              res.data.lives[i].timeFormat = timeFormat
              res.data.lives[i].timeLimit = timeLimit
            }
          })
          this.lives = res.data.lives
          this.screen_advert = res.data.screen_advert ? res.data.screen_advert : []
          setTimeout(() => {
            this.loading = false
          }, 500)
          this.setAdShow()
        })
      } else if (scene === 'homebanner') {
        Interface.getData('get', Interface.banner).then(res => {
          this.banners = res.data
        })
      } else if (scene === 'userinfo') {
        Interface.getData('get', Interface.user.user_info).then(res => {
          if (res.code === 0 || res.code === 1) {
            this.user = res.data
          }
        })
      }
    },
    go_detail(item) {
      if (item.type != 2) {
        this.$router.push({ name: 'course-detail', params: { id: item.id } })
      } else {
        this.$router.push({ name: 'course-column', params: { id: item.id } })
      }
    },
    go_live_detail(item) {
      if (item.type === 2) {
        this.$router.push({ name: 'live-column', params: { id: item.id } })
      } else if (item.live_status === 6) {
        // 回放状态
        Interface.getData('post',Interface.footprint, {
          id: item.id,
          type: 92,
          content_type: 0,
          page_type: 1,
          source_type: 0,
          parent_id: 0,
          record_id: 0,
          title: '点击看回放按钮',
          extend_title: item.title
        }).then( (res) => {
          if (res.code == 0) {
            this.$router.push({ name: 'live-detail-home', params: { id: item.id, contentType: 3 } })
          }
        }).catch((err) => {
          this.$router.push({ name: 'live-detail-home', params: { id: item.id,  contentType: 3 } })
        })
      } else {
        if (item.live_status === 0) {
          // 一键预约
          Interface.getData('post',Interface.footprint, {
            id: item.id,
            type: 92,
            content_type: 0,
            page_type: 1,
            source_type: 0,
            parent_id: 0,
            record_id: 0,
            title: '点击一键预约按钮',
            extend_title: item.title
          }).then( (res) => {
            if (res.code == 0) {
              this.$router.push({ name: 'live-detail', params: { id: item.id }, query: { pageType: 1} })
            }
          }).catch((err) => {
            this.$router.push({ name: 'live-detail', params: { id: item.id }, query: { pageType: 1} })
          })
        } else {
          // 直播中
          Interface.getData('post',Interface.footprint, {
            id: item.id,
            type: 92,
            content_type: 0,
            page_type: 1,
            source_type: 0,
            parent_id: 0,
            record_id: 0,
            title: '点击进入直播间按钮',
            extend_title: item.title
          }).then( (res) => {
            if (res.code == 0) {
              this.$router.push({ name: 'live-detail-home', params: { id: item.id, contentType: 2 } })
            }
          }).catch((err) => {
            this.$router.push({ name: 'live-detail-home', params: { id: item.id, contentType: 2  } })
          })
          Interface.mFootPrint(item.id,4,3,1,0,0,0,item.title)
          //  Interface.mFootPrint(item.id,4,3,1,0,0,0,item.title)
        }
      }

    },
    go_video_detail(item) {
      if (item.type === 2) {
        this.$router.push({ name: 'video-column', params: { id: item.id } })
      } else {
        this.$router.push({ name: 'video-detail', params: { id: item.id } })
      }
    },
    go_article_detail(item) {
      if (item.type === 2) {
        this.$router.push({ name: 'article-column', params: { id: item.id } })
      } else {
        this.$router.push({ name: 'article-detail', params: { id: item.id } })
      }
    },
    toDoctor() {
      LocationHref('https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=expert')
    },
    goList(name, remark, id) {
      // Interface.footPrint(18, id, 0, '点击首页金刚区按钮 ' + remark)

      this.$router.push({
        name: name
      })
    },
    goGuide() {
      // Interface.footPrint(18, 4, 0, '点击首页金刚区按钮 ')
      this.$router.push({ path: '/guide-category/0' })
    },
    onSwipeChange(row) {
      this.activeSwiper = row
    },
    goLink() {
      LocationHref(this.message_notice[this.activeSwiper].link)
      // console.log(this.message_notice[this.activeSwiper].title)
      Interface.footPrint1('64', this.message_notice[this.activeSwiper].id)
    },
    // 设置广告1天展示一次
    setAdShow() {
      if (this.screen_advert.length == 0) {
        return
      }
      let start_time = new Date(this.screen_advert[0].start_time).getTime()
      let end_time = new Date(this.screen_advert[0].end_time).getTime()
      let current_time = new Date().getTime()
      if (current_time > end_time || current_time < start_time) {
        return
      }
      let flag = false
      // 读取cookie
      if (document.cookie && document.cookie.length) {
        let cookieArr = document.cookie.split(';')
        for (let i = 0; i < cookieArr.length; i++) {
          let arr = cookieArr[i].split('=')
          if (arr[0].trim() == 'firstEnter') {
            flag = true
          }
        }
      }
      if (!flag) {
        let curDate = new Date()
        let curTamp = curDate.getTime()
        // 当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
        // toLocaleDateString() 根据本地时间格式，把 Date 对象的日期部分转换为字符串。
        // 如：会把Thu May 21 2020 20:41:59 GMT+0800 (中国标准时间)  转换成  2020/5/21
        let curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1
        // 当日已经过去的时间（毫秒）
        let passedTamp = curTamp - curWeeHours
        // 当日剩余时间  一天共有24 * 60 * 60 * 1000 = 86,400,000毫秒
        let leftTamp = 24 * 60 * 60 * 1000 - passedTamp
        let leftTime = new Date()

        leftTime.setTime(leftTamp + curTamp)
        // 创建cookie
        document.cookie = 'firstEnter=have' + ';expires=' + leftTime.toUTCString()
        this.adShow = true
      }
    },
    adJump() {
      if (this.screen_advert && this.screen_advert.length > 0) {
        Interface.getData('get', Interface.course.ad_click + '/' + this.screen_advert[0].id + '/view').then(
          res => {
            // console.log('===', res.data)
          }
        )
        LocationHref(this.screen_advert[0].link)
      }
    },
    onLoad() {
      Interface.getData('get', Interface.content_recommend, { page: this.pageNum, pageSize: 10 }).then(res => {
        if (res.code == 0) {
          this.listLoading = false
          if (res.data.list && res.data.list.length) {
            this.pageNum++
            this.recommend = this.recommend.concat(
              res.data.list.filter(item => {
                return item.type != 13
              })
            )
          } else {
            this.finished = true
          }
          // if (this.pageNum  > 131) {
          //   this.finished = true;
          // }
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.listLoading = true
      this.onLoad()
    },
    goBanner(item){
      Interface.mFootPrint(item.id,62,0,1,0,0,0,item.title)
    },
    goSearch() {
      this.$router.push({ name: 'search', query: { pageType: 1 } })
      Interface.mFootPrint(0,76,0,1,0,0,0,'首页-搜索')
    },
    goMore() {
      this.$router.push({ name: 'live-list' })
      Interface.mFootPrint(0,91,0,1,0,0,0,'首页点击查看更多')
    }
  },
  created() {
    Interface.getShareInfo(this, '博医同行', '', '大病患者互助医疗社区', 19, '',Interface.host + '/#/?source_type=1')
    let source_type = Interface.getUrl(window.location.href)
    if (source_type) {
      Interface.getData('post',Interface.footprint, {
        id: 1,
        type: 19,
        content_type: 0,
        page_type: 1,
        source_type: source_type,
        parent_id: 0,
        record_id: 0,
        title: '博医同行首页'
      }).then( (res) => {
        if (res.code == 0) {
          this.record_id = res.data.record_id
        }
      })
    } else {
      Interface.getData('post',Interface.footprint, {
        id: 1,
        type: 19,
        content_type: 0,
        page_type: 1,
        source_type: 0,
        parent_id: 0,
        record_id: 0,
        title: '博医同行首页'
      }).then( (res) => {
        if (res.code == 0) {
          this.record_id = res.data.record_id
        }
      })
    }
    this.fetch('homepage')
    this.fetch('homebanner')
    this.fetch('recommend')
    this.fetch('userinfo')
      Interface.CoFootPrint(6)
    sessionStorage.removeItem('search_data')
  },
  activated() {
    this.active = 0
  },
  beforeRouteLeave(to, from, next) {
    if (this.record_id) {
      Interface.mFootPrint(1, 19,0, 1, 0, 0,this.record_id,'博医同行首页')
    }
    next()
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue